export enum Unit {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
}
